import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_Student_Demographics } from "../../shared/data.service";
import { GuardianInsertRequest } from "./GuardianInsertRequest";

@Component({
	selector: "app-student-add-guardian",
	templateUrl: "./student-add-guardian.component.html",
	styleUrls: ["./student-add-guardian.component.css"],
})
export class StudentAddGuardianComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private DemographicsService: DataService_Student_Demographics
	) {}

	ngOnInit(): void {
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;

		this.loadRelationships();
		this.loadLanguages();
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	SelectedPerson: any;

	FirstName: any = "";
	LastName: any = "";
	Address1: any = "";
	Address2: any = "";
	HomePhone: any = "";
	WorkPhone: any = "";
	CellPhone: any = "";
	City: any = "";
	State: any = "";
	Zip: any = "";
	Email: any = "";

	RelationshipID: any;
	lstRelationship: any = [];

	LanguageID: any;
	lstLanguage: any = [];

	errorMessage: any = "";

	///////////////////////////////////////

	///////////////////////////////////////
	// Load Data
	///////////////////////////////////////
	loadRelationships() {
		var result = this.DemographicsService.RelationshipInfoGetList(this.SelectedPerson.SchoolID);
		result.subscribe(
			(response) => {
				this.lstRelationship = response;

				this.RelationshipID = this.lstRelationship[0].RelationshipID;
			},
			(error) => {}
		);
	}
	loadLanguages() {
		var result = this.DemographicsService.LanguageInfoGetList();
		result.subscribe(
			(response) => {
				this.lstLanguage = response;

				this.LanguageID = this.lstLanguage[0].LanguageID;
			},
			(error) => {}
		);
	}
	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////
	onAdd() {
		//Error handling
		if (this.FirstName == "") {
			this.errorMessage = "Enter first name";
		} else if (this.LastName == "") {
			this.errorMessage = "Enter last name";
		} else if (this.Address1 == "") {
			this.errorMessage = "Enter street address";
		} else if (this.City == "") {
			this.errorMessage = "Enter city or town";
		} else if (this.State == "") {
			this.errorMessage = "Enter state";
		} else if (this.Zip == "") {
			this.errorMessage = "Enter zip";
		} else {
			let parms: GuardianInsertRequest = {
				StudentPersonID: this.SelectedPerson.PersonID,
				SchoolID: this.SelectedPerson.SchoolID,
				ParentFName: this.FirstName,
				ParentLName: this.LastName,
				ParentStreet1: this.Address1,
				ParentStreet2: this.Address2,
				ParentCity: this.City,
				ParentState: this.State,
				ParentZip: this.Zip,
				RelationshipID: this.RelationshipID,
				ParentHomePhone: this.HomePhone,
				ParentWorkPhone: this.WorkPhone,
				ParentCellPhone: this.CellPhone,
				ParentEmail: this.Email,
				ParentPager: "",
				Home_LanguageID: this.LanguageID,
			};

			var result = this.DemographicsService.GuardianInsert(parms);
			result.subscribe(
				(response) => {
					if (response) {
						//Success Dialog
						this.confirmationService.confirm({
							key: "add",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Guardian was added successfully",
							header: "Success",
							icon: "fa",
							accept: () => {
								this.ref.close(1);
							},
						});
					} else {
						//Fail Dialog
						this.confirmationService.confirm({
							key: "add",
							acceptLabel: "Ok",
							rejectVisible: false,
							message: "Could Not add the Guardian",
							header: "ERROR",
							icon: "fa",
							accept: () => {},
						});
					}
				},
				(error) => {}
			);
		}
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////
}
